import { render, staticRenderFns } from "./Receipt.vue?vue&type=template&id=6e524e54&scoped=true"
import script from "./Receipt.vue?vue&type=script&lang=ts"
export * from "./Receipt.vue?vue&type=script&lang=ts"
import style0 from "./Receipt.vue?vue&type=style&index=0&id=6e524e54&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e524e54",
  null
  
)

export default component.exports